/** Returns the first matching element below a query root. @param {string} sel @param {ParentNode} [root=document] @returns {Element|null} */
export const qs = (sel, root = document) => root.querySelector(sel);
/** Returns all matching elements below a query root. @param {string} sel @param {ParentNode} [root=document] @returns {Element[]} */
export const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));
/** Constrains a number to an inclusive range. @param {number} n @param {number} lo @param {number} hi @returns {number} */
export const clamp = (n, lo, hi) => Math.max(lo, Math.min(hi, n));
/** Reads a block's configured round total, defaulting to 1 for unset or invalid values. @param {Element} blockEl @returns {number} */
export const getTotalRounds = (blockEl) => parseInt(blockEl.getAttribute('data-rounds') || '1', 10);
/** Thin diagnostic console wrapper when a browser localStorage object is present. @param {...unknown} args @returns {void} */
export const log = (...args) => {
  // eslint-disable-next-line no-console -- The one sanctioned diagnostic sink.
  if (typeof window !== 'undefined' && window?.localStorage) console.log('[progress]', ...args);
};

/** Builds the canonical identifier for a programme day. @param {number|string} week @param {number|string} day @returns {string} */
export const idFor = (week, day) => `w${week}d${day}`;
/** Builds a legacy per-exercise completion key. @param {number|string} week @param {number|string} day @param {string} ex @returns {string} */
export const exKey = (week, day, ex) => `${idFor(week, day)}:${ex}`;
/** Builds a block progress key. @param {number|string} week @param {number|string} day @param {string} blockId @returns {string} */
export const blockKey = (week, day, blockId) => `${idFor(week, day)}::${blockId}`;
/** Builds a zero-based round-specific exercise key. @param {number|string} week @param {number|string} day @param {string} blockId @param {number} roundIndex @param {string} exId @returns {string} */
export const exRoundKey = (week, day, blockId, roundIndex, exId) =>
  `${idFor(week, day)}::${blockId}::r${roundIndex}:${exId}`;

/** Counts completed round-history entries with a canonical-key prefix. @param {string} prefix @param {Record<string, boolean>} map @returns {number} */
export function countExerciseRoundsDoneFor(prefix, map) {
  let done = 0;
  for (const k in map) {
    if (Object.prototype.hasOwnProperty.call(map, k)) {
      if (k.startsWith(prefix) && map[k]) done++;
    }
  }
  return done;
}
